module.exports = {
    tag: 'penetration',
    quality: 0.7
};